<template>
	<v-tooltip
		open-delay="150"
		:disabled="!tooltipText && !$slots['tooltipContent']"
	>
		<template v-slot:activator="{ props }">
			<!-- See comment about `inheritAttrs` in <script> for an explanation for what is happening with $attrs -->
			<v-btn
				v-bind="{ ...props, ...$attrs }"
				:width="width"
				:class="btnClass"
			>
				<!-- Need to handle min max size correctly -->
				<slot name="btnContent">
					<v-icon v-if="btnIcon">{{ btnIcon }}</v-icon>
					<span v-if="btnText">{{ btnText }}</span>
				</slot>
			</v-btn>
		</template>
		<slot name="tooltipContent">{{ tooltipText }}</slot>
	</v-tooltip>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
	name: "TooltipButton",
	/*
	 *	By default Vue passes attributes to the root element of the component. In this case that would be the v-tooltip
	 *	component. We actually want to pass these to the v-btn inside the v-tooltip so we disable the automatic
	 *	fallthrough behaviour and manually pass attributes to the v-btn.
	 *
	 *	We also want to pass the activator for the tooltip to the v-btn so we merge it with the attributes.
	 *
	 *	Relevant Vue documentation: https://vuejs.org/guide/components/attrs.html#accessing-fallthrough-attributes-in-javascript
	 */
	inheritAttrs: false,
	props: {
		btnClass: { type: String },
		btnText: { type: String },
		btnIcon: { type: String },
		tooltipText: { type: String },
	},
	computed: {
		width(): undefined | string {
			if (this.$attrs.icon) {
				return undefined;
			} else if (this.$attrs.width) {
				return this.$attrs.width as string;
			}
			return undefined;
		},
	},
});
</script>
